import Vue from 'vue'
import VueRouter from 'vue-router'
import SimpleCrypto from 'simple-crypto-js'

import cadastroRoutes from '../modules/PABX/modules/cadastros/routes'
import rotasRoutes from '../modules/PABX/modules/regrasDeNegocios/routes'
import relatoriosRoutes from '../modules/PABX/modules/relatorios/routes'
import agendamentoRoutes from '../modules/PABX/modules/agendamento/routes'
import monitorRoutes from '../modules/PABX/modules/monitor/routes'
import configuracoesRoutes from '../modules/PABX/modules/configuracoes/routes'
import UserRoutes from '../modules/users/modules/userRegister/_routes'
import RoleRoutes from '../modules/users/modules/roleRegister/_routes'
import AuditRoutes from '../modules/users/modules/audit/_routes'
import cadastrosCallCenterRoutes from '../modules/CallCenter/modules/cadastro/routes'
import MonitorCallCenterRoutes from '../modules/CallCenter/modules/monitor/_routes'
import MonitorOperadorCallCenterRoutes from '../modules/CallCenter/modules/monitorOperador/_routes'
import configCallCenterRoute from '../modules/CallCenter/modules/configCallCenter/_routes'
import relatoriosCallCenterRoutes from '../modules/CallCenter/modules/relatorios/routes'
import gerenciamentoCallCenterRoutes from '../modules/CallCenter/modules/gerenciamento/_routes'
import TokenRoutes from '../modules/users/modules/tokenRegister/_routes'
import relatoriosPabxChamadasRoutes from '../modules/relatoriosPABX/modules/chamadas/_routes'
import relatoriosPabxConferenciasRoutes from '../modules/relatoriosPABX/modules/conferencias/_routes'
import cadastroPesquisaSatisfacaoRoutes from '../modules/satisfactionResearch/modules/cadastros/routes'
import relatoriosPesquisaSatisfacaoRoutes from '../modules/satisfactionResearch/modules/relatorios/routes'
import integracoesRoutes from '../modules/PABX/modules/integracoes/routes'

const Layout = () => import(/* webpackChunkName: "group-pabx" */ '../modules/PABX/views/PabxLayout')
const Login = () => import(/* webpackChunkName: "group-login" */ '../modules/login/_views/Login')
const CallCenter = () =>
  import(/* webpackChunkName: "group-callcenter" */ '../modules/CallCenter/views/CallCenterLayout')
  const Select = () => import(/* webpackChunkName: "select-module" */ '../modules/login/_views/Select')
  const Users = () => import(/* webpackChunkName: "group-users" */ '../modules/users/views/Users')
  const MonitorHome = () => import(/* webpackChunkName: "group-monitor" */ '../modules/monitor/views/MonitorHome')
const MonitorCallCenterHome = () =>
  import(
    /* webpackChunkName: "group-callcenter" */ '../modules/CallCenter/modules/monitor/_views/MonitorCallCenterHome'
  )
  const MonitorOperadorCallCenterHome = () =>
  import(
    /* webpackChunkName: "group-callcenter" */ '../modules/CallCenter/modules/monitorOperador/_views/MonitorOperadorCallCenterHome'
  )
const LoginOperador = () =>
  import(/* webpackChunkName: "login-operador" */ '../modules/loginOperador/_views/LoginOperador')
const OperadorScreen = () => import(/* webpackChunkName: "group-operador" */ '../modules/operador/views/OperadorScreen')
const RelatoriosPABXHome = () =>
  import(/* webpackChunkName: "group-relatorios-pabx"*/ '../modules/relatoriosPABX/views/RelatoriosPABXLayout')
const SatisfactionResearchHome = () =>
  import(
    /* webpackChunkName: "group-satisfaction-research"*/ '../modules/satisfactionResearch/views/SatisfactionResearchLayout'
  )
const AdministrativePainel = () =>
  import(/* webpackChunkName: "group-pabx"*/ '../modules/AdministrativePainel/_views/AdministrativePainel')

import {
  callCenterPermissions,
  monitorRamaisPermissions,
  pabxPermissions,
  relatoriosPABXPermissions,
  satisfactionResearchPermissions,
  usersModulePermissions,
} from '../utils/arraysPermissions'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/login',
    },
    {
      path: '/login',
      component: Login,
      meta: { requiresAuth: false },
      name: 'login',
    },
    {
      path: '/verify_rota',
      meta: { requiresAuth: true },
      name: 'Verify_Rota',
    },
    {
      path: '/operador',
      component: LoginOperador,
      meta: { requiresAuth: false },
      name: 'loginOperador',
    },
    {
      path: '/tela-operador',
      component: OperadorScreen,
      meta: { requiresAuthOperador: true },
      name: 'operator-screen',
    },
    {
      path: '/painel-administrativo',
      component: AdministrativePainel,
      meta: { requiresAuth: true, permissions: [...pabxPermissions] },
      name: 'administrative_panel',
    },
    {
      path: '/monitor-ramais',
      component: MonitorHome,
      meta: { requiresAuth: true, permissions: [...monitorRamaisPermissions] },
      name: 'onlyMonitor',
    },
    {
      path: '/monitor-filas',
      component: MonitorCallCenterHome,
      meta: { requiresAuth: true, permissions: [...callCenterPermissions] },
      name: 'onlyMonitorCallCenter',
    },
    {
      path: '/monitor-operador',
      component: MonitorOperadorCallCenterHome,
      meta: { requiresAuth: true, permissions: [...callCenterPermissions] },
      name: 'onlyMonitorOperador',
    },
    {
      path: '/controle-de-acesso',
      component: Users,
      meta: { requiresAuth: true, permissions: [...usersModulePermissions] },
      name: 'AccessControl',
      children: [...UserRoutes, ...RoleRoutes, ...TokenRoutes, ...AuditRoutes],
    },
    {
      path: '/pabx',
      component: Layout,
      meta: { requiresAuth: true, permissions: [...pabxPermissions] },
      name: 'pabx',
      redirect: { name: 'monitor' },
      children: [
        ...cadastroRoutes,
        ...rotasRoutes,
        ...relatoriosRoutes,
        ...agendamentoRoutes,
        ...monitorRoutes,
        ...configuracoesRoutes,
        ...integracoesRoutes,
      ],
    },
    {
      path: '/central-de-atendimento',
      component: CallCenter,
      meta: { requiresAuth: true, permissions: [...callCenterPermissions] },
      name: 'callcenter',
      children: [
        ...cadastrosCallCenterRoutes,
        ...relatoriosCallCenterRoutes,
        ...MonitorCallCenterRoutes,
        ...MonitorOperadorCallCenterRoutes,
        ...configCallCenterRoute,
        ...gerenciamentoCallCenterRoutes,
      ],
    },
    {
      path: '/select',
      component: Select,
      meta: { requiresAuth: false },
      name: 'select_module',
    },
    {
      path: '/relatorios-pabx',
      component: RelatoriosPABXHome,
      meta: { requiresAuth: true, permissions: [...relatoriosPABXPermissions] },
      name: 'relatorios_pabx',
      children: [...relatoriosPabxChamadasRoutes, ...relatoriosPabxConferenciasRoutes],
    },
    {
      path: '/pesquisa-satisfacao',
      component: SatisfactionResearchHome,
      meta: { requiresAuth: true, permissions: [...satisfactionResearchPermissions] },
      name: 'satisfaction_research',
      children: [...cadastroPesquisaSatisfacaoRoutes, ...relatoriosPesquisaSatisfacaoRoutes],
    },
  ],
})
router.beforeEach(async (to, from, next) => {
  if (to.matched.some(route => route.meta.requiresAuthOperador)) {
    const tokenOperador = window.localStorage.getItem('pcm_access_token_operador')
    if (tokenOperador) {
      return next()
    } else {
      return next({ name: 'loginOperador' })
    }
  }

  if (to.matched.some(route => route.meta.requiresAuth)) {
    const token = window.localStorage.getItem('pcm_access_token')

    if (token) {
      const simpleCrypto = new SimpleCrypto(process.env.VUE_APP_CRYPTO)
      const arrayPermissionsJSON = localStorage.getItem('pcm_permissions')
      const arrayPermissions = simpleCrypto.decrypt(arrayPermissionsJSON)
      if (to.name === 'Verify_Rota') {
        let canCallCenter = false
        let canUser = false
        let canSatisfactionResearch = false
        let canRelatoriosPabx = false
        let canMonitorRamais = false
        let canPabx = false
        let totalPermissions = 0

        arrayPermissions.forEach(permissionLocalStorage => {
          if (callCenterPermissions.includes(permissionLocalStorage) && !canCallCenter) {
            canCallCenter = true
            totalPermissions += 1
          }
          if (monitorRamaisPermissions.includes(permissionLocalStorage) && !canMonitorRamais) {
            canMonitorRamais = true
            totalPermissions += 1
          }
          if (pabxPermissions.includes(permissionLocalStorage) && !canPabx) {
            canPabx = true
            totalPermissions += 1
          }
          if (relatoriosPABXPermissions.includes(permissionLocalStorage) && !canRelatoriosPabx) {
            canRelatoriosPabx = true
            totalPermissions += 1
          }
          if (satisfactionResearchPermissions.includes(permissionLocalStorage) && !canSatisfactionResearch) {
            canSatisfactionResearch = true
            totalPermissions += 1
          }
          if (usersModulePermissions.includes(permissionLocalStorage) && !canUser) {
            canUser = true
            totalPermissions += 1
          }
        })

        if (totalPermissions > 1) {
          return next({ name: 'select_module' })
        }

        if (totalPermissions > 0) {
          if (canPabx) {
            return next({ name: 'pabx' })
          }
          if (canCallCenter) {
            return next({ name: 'callcenter' })
          }
          if (canUser) {
            return next({ name: 'AccessControl' })
          }
          if (canSatisfactionResearch) {
            return next({ name: 'satisfaction_research' })
          }
          if (canRelatoriosPabx) {
            return next({ name: 'relatorios_pabx' })
          }
          if (canMonitorRamais) {
            return next({ name: 'onlyMonitor' })
          }
        }
        window.localStorage.removeItem('pcm_access_token')
        window.localStorage.removeItem('pcm_permissions')
        return next({ name: 'login' })
      } else {
        let canGoForward = false

        arrayPermissions.forEach(permissionLocalStorage => {
          if (to.meta.permissions.includes(permissionLocalStorage)) {
            canGoForward = true
          }
        })
        if (canGoForward) {
          return next()
        } else {
          return next({ name: 'select_module' })
        }
      }
    } else {
      window.localStorage.removeItem('pcm_access_token')
      window.localStorage.removeItem('pcm_permissions')
      return next({ name: 'login' })
    }
  }
  next()
})

export default router
